import React from 'react';

const DoubleArrowChunkySvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 20l1.4-1.4L7.8 16H20v-2H4v1l5 5zM15 4l-1.4 1.4L16.2 8H4v2h16V9z"
        />
    </svg>
);

DoubleArrowChunkySvg.displayName = 'DoubleArrowChunkySvg';
export default DoubleArrowChunkySvg;
